import { useMutation } from 'react-query';
import * as profileSignupApi from '../../api/profile/signup';
import { axiosMutationWrapper } from '../utils/axios-wrapper';

export const useSignup = () => useMutation(
	axiosMutationWrapper(profileSignupApi.signup),
);
